import { Slider, styled } from "@mui/material";

const PaddedSlider = styled(Slider)(({ theme }) => ({
  padding: '3em 0'
}));
export default PaddedSlider;